import { useEffect, useState } from 'react';
import { api } from '../api/client.js';

// Admin → user: the account's start.gg token for running matches from the
// console (Call, Start, scores, the bracket page's actions). Added here by
// an admin, never by the TO: the server checks it with start.gg before
// keeping it and only ever shows the account it belongs to.
export default function StartggTokenCard({ userId, enabled, onFlash }) {
  const [status, setStatus] = useState(null); // { saved, account }
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.adminGetStartggToken(userId)
      .then((s) => { if (!cancelled) setStatus(s); })
      .catch(() => { if (!cancelled) setStatus({ saved: false, account: null }); });
    return () => { cancelled = true; };
  }, [userId]);

  const run = async (work, done) => {
    setBusy(true);
    try {
      setStatus(await work());
      onFlash({ kind: 'success', msg: done });
    } catch (e) {
      onFlash({ kind: 'danger', msg: e.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-3">
      <label className="form-label" htmlFor="startgg-token">start.gg token</label>
      {status?.saved ? (
        <p className="mb-1">
          Saved — the token of start.gg account <strong>{status.account || '(unknown)'}</strong>.{' '}
          <button
            type="button"
            className="btn btn-link btn-sm p-0 align-baseline"
            disabled={busy}
            onClick={() => run(() => api.adminRemoveStartggToken(userId), 'start.gg token removed.')}
          >
            Remove
          </button>
        </p>
      ) : (
        <div className="d-flex gap-2">
          <input
            id="startgg-token"
            type="password"
            className="form-control"
            placeholder="Personal access token"
            autoComplete="off"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            disabled={busy || status == null}
          />
          <button
            type="button"
            className="btn btn-outline-primary"
            disabled={busy || !draft.trim()}
            onClick={() => run(async () => {
              const s = await api.adminSetStartggToken(userId, draft.trim());
              setDraft('');
              return s;
            }, 'start.gg token saved.')}
          >
            {busy ? 'Checking…' : 'Save'}
          </button>
        </div>
      )}
      <div className="form-text">
        What the console runs matches with (Call, Start, scores, the bracket
        page). start.gg → Developer Settings → Personal Access Tokens, from an
        account that can report on this user&apos;s tournaments. Checked with
        start.gg before it is kept; never shown again.
        {!enabled && ' This user doesn’t have "Run matches from the console" on yet.'}
      </div>
    </div>
  );
}
